export enum GeneralLink {
  ERROR = '/error',
  LOGIN_AS_USER = '/login-as-user',
  LOGOUT = '/logout',
}

// TODO Remove AdminLink once customer has started using AppAdminLink
export enum AdminLink {
  ROOT = '/admin',
  FOOD_TYPES = '/admin/hot-meals',
  STORES = '/admin/store-and-department',
  USERS = '/admin/users',
  REPORTS = '/admin/reports',
}

export enum AppAdminLink {
  ROOT = '/service-office-admin',
  FOOD_TYPES = '/service-office-admin/hot-meals',
  STORES = '/service-office-admin/store-and-department',
  USERS = '/service-office-admin/users',
  REPORTS = '/service-office-admin/reports',
}

export enum RestoAdminLink {
  ROOT = '/store-admin',
  FOOD_TRAY_TEMPLATES = '/store-admin/food-templates',
  FOOD_TRAY_TEMPLATES_EDIT = '/store-admin/food-templates/:id/edit',
  FOOD_TRAY_TEMPLATES_CREATE = '/store-admin/food-templates/create',
  USERS = '/store-admin/users',
}

export enum FrontOfficeLink {
  ROOT = '/',
  DEPARTMENT_SELECT = '/department-select',
  TEMPLATE_SELECT = '/template-select',
  DASHBOARD = '/dashboard/:id',
}
